import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

export const featureFlagsScheme = createFlagsScheme({
    isPaymentWidgetAutoOpenFromUrl: schema.boolean.optional(false),
    isSingleOfferCarouselTouchEnabled: schema.boolean.optional(false),
});
